import { useState } from "react";
import JsonEditorDialog from "../../../Components/JsonEditorDialog";

export default Body;

function Body(props) {
  const { body, onUpdate } = props;

  const [jsonEditDialog, setJsonEditDialog] = useState(false);

  return (
    <>
      <div>
        <div className="flex items-center justify-between mb-1">
          <label className="text-sm font-semibold">Body</label>
          <button
            onClick={() => setJsonEditDialog(true)}
            className="text-xs text-blue-600 hover:text-blue-700"
          >
            Edit
          </button>
        </div>
        <pre className="p-3 bg-zinc-50 rounded-lg border text-xs text-zinc-600 max-h-32 overflow-auto whitespace-pre-wrap">
          {JSON.stringify(body, null, 2) || "No body configured"}
        </pre>
      </div>
      {jsonEditDialog && (
        <JsonEditorDialog
          open={true}
          onClose={() => setJsonEditDialog(false)}
          onSave={onUpdate}
          value={JSON.stringify(body, null, 2)}
        />
      )}
    </>
  );
}
